import React from 'react';

import { Inline, Stack } from '@atlaskit/primitives/compiled';
import Skeleton from '@atlaskit/skeleton';

export const JiraUpdateWorkItemFieldsActionSkeleton = (): React.JSX.Element => {
	return (
		<Stack space="space.150" testId="conversation-assistant.ui.card-renderer-skeleton">
			<Inline space="space.100">
				<Skeleton width="16px" height="16px" />
				<Skeleton width="170px" height="16px" />
			</Inline>

			<Skeleton width="200px" height="16px" />
		</Stack>
	);
};
